import axios from "axios";

export function toApiError(err: unknown) {
  if (axios.isAxiosError(err)) {
    return err.response?.data?.message || err.message || "Request failed";
  }
  return err instanceof Error ? err.message : "Unexpected error";
}
